import { isEmpty } from "lodash";
// type
import { TMainPageLayoutV3 } from "../type";
// types
import { metaDataLanguageVersion } from "@/utilities/LanguageVersionSelectorShortcut";


const MNPG063 = ( props: TMainPageLayoutV3 ) => {
    console.log("MNPG063.rendered: ", props);
    
    const copyright = metaDataLanguageVersion("copyright", props.template?.languageVersions);
    if ( !copyright || isEmpty(copyright) ) return null;

    return (
        <p className="copyright color-2">{copyright} - <a href="https://www.armadorteknoloji.com" title="Armador Yazılım ve Teknoloji A.Ş.">Powered By Armador Yazılım ve Teknoloji A.Ş</a></p>
    )
}

export default MNPG063;
